module.exports = __webpack_public_path__ + "assets/img/icon-logo.de4994c9.png";